<template>
	<v-card>
		<v-card-title>
			<h2>Projekty</h2>
		</v-card-title>
		<v-card-text>
			<VolunteerProjectsTable/>
		</v-card-text>
	</v-card>
</template>

<script>
	import VolunteerProjectsTable from "./VolunteerProjectsTable";

	export default {
		name: "VolunteerProjectsView",
		components: {VolunteerProjectsTable},
		// data() {
		// 	return {
		//
		// 		headers: [
		// 			{text: "Nr projektu", value: "projectCode", align: "left", sortable: false},
		// 			{text: "Nazwa", value: "projectTitle", sortable: false},
		// 			{text: "Konkurs", value: "contestName", sortable: false},
		// 			{text: "Oferent", value: "bidderName", sortable: false},
		// 		],
		//
		// 		projects: []
		// 	};
		// },
		//
		// beforeMount() {
		// 	this.getProjects();
		// },
		//
		// methods: {
		// 	getProjects() {
		// 		Api.get(this,
		// 			"/projects/list?search=&page=1&result=10", response => {
		// 				this.projects = response.itemList;
		// 			});
		// 	}
		// }
	};
</script>

<style scoped>

</style>
